import * as Styled from './Footer.styled';

const Footer = () => {
  return (
    <Styled.Container>
      Adam Maliszewski © 2023
    </Styled.Container>
  );
}

export default Footer;